import { InternalAxiosRequestConfig } from "axios";
import { getCookieValue } from "src/constants/functions";
import { isAttachmentVersionedRequest } from "src/utils/attachmentVersion";
import { tokenStore } from "src/utils/tokenStore";

// export const addAuthHeader2 = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
//   const idToken = getCookieValue("idToken");
//   const refreshToken = getCookieValue("refreshToken");
//   if (!idToken && !refreshToken) {
//     logout();
//   }
//   if (idToken && refreshToken) {
//     config.headers["Authorization"] = JSON.stringify({
//       authorization: idToken,
//       refreshToken: refreshToken,
//     });
//   }
//   //to send url in upper case
//   config.baseURL = config.baseURL?.toString()?.toLocaleLowerCase();
//   const [firstPart, ...rest] = config.url?.split("?") || [];
//   config.url = firstPart?.toString() + (rest.length ? "?" + rest.join("?") : "");
//   return config;
// };

export const addAuthHeader2 = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  // Prefer in-memory access token; fall back to cookie during initial OAuth hydration.
  const accessToken = tokenStore.getAccessToken() || getCookieValue("token");

  // Do NOT logout here — let the request go out so the response interceptor
  // can catch any 401/403 and run the refresh flow.
  if (accessToken) {
    config.headers["Authorization"] = `Bearer ${accessToken}`;
  }
  // M10-14277: opt into v2 attachment serving via a QUERY PARAM (not a header) so it never
  // triggers a CORS preflight, and only for the version-gated endpoints. Absent => public URLs.
  if (isAttachmentVersionedRequest(config)) {
    config.params = { ...(config.params || {}), version: "v2" };
  }

  //to send url in upper case
  config.baseURL = config.baseURL?.toString()?.toLocaleLowerCase();
  const [firstPart, ...rest] = config.url?.split("?") || [];
  config.url = firstPart?.toString() + (rest.length ? "?" + rest.join("?") : "");
  return config;
};